/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationTargetSuggestionsFetch_idleTime = {
    readonly id: string;
    readonly name: string | null;
    readonly isInternalTime: boolean | null;
    readonly favoured: boolean | null;
    readonly disabled: boolean | null;
    readonly " $refType": "TimeRegistrationTargetSuggestionsFetch_idleTime";
};
export type TimeRegistrationTargetSuggestionsFetch_idleTime$data = TimeRegistrationTargetSuggestionsFetch_idleTime;
export type TimeRegistrationTargetSuggestionsFetch_idleTime$key = {
    readonly " $data"?: TimeRegistrationTargetSuggestionsFetch_idleTime$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TimeRegistrationTargetSuggestionsFetch_idleTime">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationTargetSuggestionsFetch_idleTime",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInternalTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "favoured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disabled",
      "storageKey": null
    }
  ],
  "type": "IdleTime"
};
(node as any).hash = 'bf8e873c19c910eb36c82c5d705d1189';
export default node;
